import { FaTwitterSquare, FaFacebookSquare, FaEnvelope } from "react-icons/fa";
import styles from "../RequestForQuotePage/index.module.css";
import { IoCopy } from "react-icons/io5";
import "react-toastify/dist/ReactToastify.css";
import "../../black-box/custom.css";
import { Modal } from "react-responsive-modal";
import React, { useEffect, useState } from "react";
import { TextField } from "@material-ui/core";
import { LoadingOverlay, Loader } from "react-overlay-loader";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReCAPTCHA from "react-google-recaptcha";//main

// import 'react-responsive-modal/styles.css';

const JSShare = ({ currentTab }) => {
    const [reCaptchaValue, setReCaptchaValue] = useState("");
    const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    const [addtolistError, setaddtolistError] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [senderName, setsenderName] = useState('');
    const [RecipientsMail, setRecipientsMail] = useState('');
    const [Massage, setMessage] = useState('');
    const [loaded, setLoaded] = useState(false);
    const [setting, setSetting] = useState('');

    var url_string = window.location;
    var url = new URL(url_string);
    var wid = atob(url.searchParams.get("wid"));

    function redirect(e, social) {

        var options = window.Shopify.shop + "/pages/gemfind-my-wishlist?wid=" + btoa(window.meta.page.customerId);

        if (social === 'facebook') {
            window.open('https://www.facebook.com/sharer.php'
                + '?u=' + encodeURIComponent(options), '_blank');

        } else if (social === 'twitter') {
            window.open('http://twitter.com/share'
                + '?url=' + encodeURIComponent(options), '_blank');


        } else if (social === 'copy') {
            navigator.clipboard.writeText(options).then(() => {
                console.log('Content copied to clipboard');
            }, () => {
                console.error('Failed to copy');
            });
        } else if (social === 'mail') {
            setIsOpen(true);
        }
    }

    const handleAppSetting = async () => {
        // setLoaded(true);
        const requestOptions = {
            method: "POST",
            body: JSON.stringify({
                shop_domain: window.Shopify.shop
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "appSetting",
            requestOptions
        );
        const app_setting = await res.json();
        setSetting(app_setting.data);

    };
    // console.log(setting);

    useEffect(() => {
        handleAppSetting();
    }, []);

    async function send() {
        setIsOpen(false);
        setLoaded(true);
        const requestOptions = {
            method: "POST",
            // mode: 'no-cors',
            body: JSON.stringify({
                shop_domain: window.Shopify.shop,
                customer_id: window.meta.page.customerId,
                sender: senderName,
                recipientsMail: RecipientsMail,
                message: Massage,
                wishlist_id: currentTab,
                title: "Share your wishlist",
                url: window.Shopify.shop + "/pages/gemfind-my-wishlist?wid=" + btoa(window.meta.page.customerId)
            })
        };
        const res = await fetch(
            `${process.env.REACT_APP_API_URL}` + "sharewishlist",
            requestOptions
        );
        const reqData = await res.json();
        if (reqData.status === "success") {
            toast("Email Sent Successfully!");
        } else {
            toast("Email Could not be sent ");
        }
        setLoaded(false);
        setReCaptchaValue("");

    }
    function onRecapchaChange(value) {
        console.log("Captcha value:", value);
        setReCaptchaValue(value);
    }

    useEffect(()=>{
        if(loaded){
            document.querySelector(".gf--loader--body").style="display:block;";
        }else{
            document.querySelector(".gf--loader--body").style="display:none;";
        }
    },[loaded]);

    return (
        <>
            {/* <LoadingOverlay className="_loading_overlay_wrapper">
                <Loader fullPage loading={loaded} />
            </LoadingOverlay> */}
            <div className="gf-wishlist-share hidden">
                {window.meta.page.customerId != undefined && btoa(wid) == 'null' ? (
                    <>
                        <p>Share On</p>

                        {/* <div class="tooltip">
                            <button onClick={(e) => redirect(e, 'copy')} ><IoCopy className={styles.copycontainer} /></button>
                            <span class="tooltiptext">
                                Copy URL
                            </span>
                        </div> */}

                        <button onClick={(e) => redirect(e, 'facebook')} ><FaFacebookSquare
                            className={styles.facebookcontainer}
                        /></button>
                        <button onClick={(e) => redirect(e, 'twitter')} ><FaTwitterSquare
                            className={styles.twittercontainer}
                        /></button>

                        <button onClick={(e) => redirect(e, 'mail')} ><FaEnvelope
                            className={styles.mailcontainer}
                        /></button>

                        <Modal
                            open={isOpen}
                            onClose={() => setIsOpen(false)}
                            center
                            classNames={{
                                overlay: "popup_Overlay",
                                modal: "popup-form-extra-small"
                            }}
                        >
                            <div>
                                <p className="gf-wishlist-head">Add - Sender Email and Recipients Name fields in the form.</p>
                                <h3 className="gf-wishlist-head" style={{ marginTop: "5px" }}>Share Wishlist Via Email</h3>
                            </div>
                            <form className="share-email-form" >
                                <div className="form-field">
                                    <TextField
                                        type="text"
                                        label="Recipients name"
                                        variant="filled"
                                        value={senderName}
                                        onChange={(e) => { setsenderName(e.target.value) }}
                                    />

                                    <TextField
                                        type="email"
                                        label="Recipients Email*"
                                        variant="filled"
                                        value={RecipientsMail}
                                        onChange={(e) => { setRecipientsMail(e.target.value); }}
                                    />
                                    <TextField
                                        type="text"
                                        label="Message"
                                        variant="filled"
                                        value={Massage}
                                        onChange={(e) => { setMessage(e.target.value) }}
                                    />
                                    {setting.site_key != null ?
                                        <ReCAPTCHA
                                            sitekey={setting.site_key}
                                            onChange={onRecapchaChange}
                                        />
                                        : ""}
                                    {addtolistError ? <small className="gf-error-msg">* Please enter valid Email</small> : ''}
                                    <div style={{ marginTop: "10px" }}>
                                        <div>
                                            {setting.site_key != null ?
                                                <button
                                                    disabled={
                                                        reCaptchaValue ? false : true
                                                    }
                                                    type="button"
                                                    className="btn button preference-btn"
                                                    onClick={() =>
                                                        RecipientsMail != '' && RecipientsMail.match(isValidEmail) ? send() : setaddtolistError(true)
                                                    }

                                                >
                                                    <span>Submit Inquiry</span>
                                                </button>
                                                :
                                                <button
                                                    
                                                    type="button"
                                                    className="btn button preference-btn"
                                                    onClick={() =>
                                                        RecipientsMail != '' && RecipientsMail.match(isValidEmail) ? send() : setaddtolistError(true)
                                                    }

                                                >
                                                    <span>Submit Inquiry</span>
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </div>

                            </form>

                        </Modal>
                    </>
                ) : ''}
            </div>
        </>
    )
}

export default JSShare;